import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  userImage: {
    width: '100px',
    height: '100px',
    margin: '5px',
    float: 'left'
  },
  tag: {
    margin: '0px 10px 0px 0px'
  }
};

const enhance = compose(pure);

const ShopTable = enhance(({ classes, detail }) => {
  return (
    <Table className={classes.detailTable}>
      <TableRow>
        <TableCell className={classes.tableCellItem}>店舗名</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.preShopName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>郵便番号</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.zipCode}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>住所</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.prefectures}
          {` `}
          {detail.city}
          {` `}
          {detail.address}
          {` `}
          {detail.building}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>電話番号</TableCell>
        <TableCell className={classes.tableCellData}>{detail.phone}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>
          店舗へのメッセージ
        </TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.message}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>画像</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.images.map(image => {
            return (
              <Card className={classes.userImage}>
                <CardActionArea>
                  <CardMedia component="img" image={image.image} />
                </CardActionArea>
              </Card>
            );
          })}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>お値段ごち</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.preGochis.map(preGochi => {
            return (
              <div>
                {preGochi.displayName}
                &#40;
                {preGochi.accountId}
                &#41;&#91;
                {preGochi.amount ? `${preGochi.amount}円` : '仮店舗登録ユーザ'}
                &#93;
              </div>
            );
          })}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>タグ</TableCell>
        <TableCell className={classes.tableCellData}>
          <div>
            {detail.tags.map(tag => {
              return <span className={classes.tag}>{tag.tagName}</span>;
            })}
          </div>
        </TableCell>
      </TableRow>
    </Table>
  );
});

export default withStyles(styles)(ShopTable);
